<template>
  <b-form-group 
    v-if="max" 
    class="label-text-wrapper"
  >
    <template #label>
      <div class="d-flex justify-content-between">
        <div v-if="label">
          <span
            class="label-text"
          >{{ label }}</span>
          <i
            v-if="copy"
            v-b-tooltip.hover.viewport.noninteractive="copied ? 'Copied!' : 'Duplicate text field'"
            data-action="copy"
            :class="['cursor-pointer font-xl pr-2 bi pl-0', copied ? 'bi-check2' : 'bi-copy']"
            style="font-size: 0.75rem !important;"
            @click="copyTextToClipboard"
          />
        </div>
        <slot
          v-else
          name="label"
        />
        <div>
          <b-badge
            :variant="state === null ? 'success' : 'danger'"
            class=""
          >
            {{ count }}/{{ max }}
          </b-badge>
          <b-icon
            v-if="maxEditable"
            id="edit-max-chars"
            icon="pencil"
            class="cursor-pointer"
          />
          <b-popover
            v-if="maxEditable"
            target="edit-max-chars"
            placement="bottomleft"
            :show.sync="popoverShow"
          >
            <b-input
              v-model="editableMaxChars"
              class="mb-2"
            />
            <b-button
              variant="primary"
              @click="editMaxCharsHandler"
            >
              Update
            </b-button>
          </b-popover>
        </div>
      </div>
    </template>
    <slot :state="state" />
  </b-form-group>
  <b-form-group
    v-else
    :label="label"
  >
    <slot />
  </b-form-group>
</template>

<script>
export default {
  name: 'FormGroupCharLimit',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: ''
    },
    max: {
      type: Number,
      default: null,
    },
    maxEditable: {
      type: Boolean,
      default: () => false,
    },
    copy: {
      type: Boolean,
      default: () => false
    },
  },
  data: () => ({
    editableMaxChars: 0,
    popoverShow: false,
    copied: false,
  }),
  computed: {
    stringValue() {
      return this.value + '';
    },
    state () {
      return this.count <= this.max && null
    },
    count () {
      return this.stringValue.replace(/<[^>]*>/g, '').length
    },
  },
  watch: {
    max(value) {
      this.editableMaxChars = value;
    },
  },
  mounted() {
    this.editableMaxChars = this.max;
  },
  methods: {
    editMaxCharsHandler() {
      this.$emit('change', Number(this.editableMaxChars))
      this.popoverShow = false
    },
    copyTextToClipboard() {
      this.$emit('copy')
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 1000);
    },
  }
}
</script>

<style lang="scss" scoped>
.badge {
  font-size: .75rem !important;
  line-height: 1 !important;
}
.label-text-wrapper .label-text {
  font-size: 0.92rem;
}
.form-group .label-text-wrapper legend {
  padding-bottom: 4px !important;
}
</style>
